import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PucaQuestionnaireService {


	constructor(public http: HttpClient) { }

	public saveApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'puca/saveApplication', {data:payload})
	}

}
